// extracted by mini-css-extract-plugin
export default {"undoButton":"Game_undoButton__kwllL","restartButton":"Game_restartButton__oM4GF","blink":"Game_blink__2UF6L"};